module.exports = __webpack_public_path__ + "static/media/qcode.3b40cb00.png";